import { render, staticRenderFns } from "./AddAdfsWhiteListDialog.vue?vue&type=template&id=803c87ea"
import script from "./AddAdfsWhiteListDialog.vue?vue&type=script&lang=js"
export * from "./AddAdfsWhiteListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports